import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import MUIAlertModal from '../../../shared/MUIAlertModal';

export const DeleteDomesticCountryDialog = ({
  open,
  onClose,
  onSubmit,
  selectedRow,
  localized,
  dialogError,
}) => {
  return (

       <MUIAlertModal
          open = { open }
            onClose = { onClose }
            title = { localized.AreYouSure }
            message = {
                <>
                  <h3>
                    {selectedRow?.countryCode} - {selectedRow?.displayName}
                  </h3>
                  <p>{localized.AreYouSureDeleteDomesticCountry}</p>
            {
                dialogError && (
                    <Alert severity="error" sx={{ marginTop: "16px" }}>
                        {dialogError}
                    </Alert>
                )
            }
                </>
              }
        confirmLabel = { localized.Delete }
        cancelLabel = { localized.Cancel }
        onConfirm = { async(event) => {
            event.preventDefault();
            const success = await onSubmit();
            if (success) {
                onClose();
            }
        }}
        confirmButtonProps={{ color: "error" }}
         cancelButtonProps={{ color: "update" }}
        />
  );
};

DeleteDomesticCountryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedRow: PropTypes.object,
  localized: PropTypes.object.isRequired,
  dialogError: PropTypes.string,
};
